export enum SupportedTimezones {
	Rome = 'Europe/Rome',
}
